import { render } from "./BaseIcon.vue?vue&type=template&id=1611e29d&scoped=true"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"

import "./BaseIcon.vue?vue&type=style&index=0&id=1611e29d&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1611e29d"]])

export default __exports__